'use client'

import { TranslationControl } from '@marketplace-web/i18n/translations-feature'

import { useFeedbackContext } from '../../FeedbackProvider'

type Props = {
  feedbackId: number
}

const FeedbackTranslationButton = ({ feedbackId }: Props) => {
  const { getFeedbackItemStateById, initiateTranslation } = useFeedbackContext()

  const isTranslated = getFeedbackItemStateById(feedbackId)?.isTranslated

  const handleInitiateTranslation = () => {
    initiateTranslation(feedbackId, !isTranslated)
  }

  return (
    <TranslationControl
      isTranslated={isTranslated}
      autotranslate={false}
      onClick={handleInitiateTranslation}
      tracking={{
        target: 'translate_feedback',
        targetDetails: feedbackId.toString(),
      }}
    />
  )
}

export default FeedbackTranslationButton
